import { gql } from '@apollo/client'

import { METADATA_NODE_FRAGMENT } from '../../../common/graphql/fragments'

const DISH_TYPE_NODE_FRAGMENT = gql`
  fragment DishTypeNodeFragment on DishTypeNode {
    ...MetadataNodeFragment
    isIgnored

    replaces {
      ...MetadataNodeFragment
      replaceToken
    }

    replacedBy {
      ...MetadataNodeFragment
      replaceToken
    }

    courseTypeNode {
      id
      name
    }
    children {
      ...MetadataNodeFragment
      isIgnored

      replaces {
        ...MetadataNodeFragment
        replaceToken
      }

      replacedBy {
        ...MetadataNodeFragment
        replaceToken
      }

      courseTypeNode {
        id
        name
      }
      children {
        ...MetadataNodeFragment
        isIgnored

        replaces {
          ...MetadataNodeFragment
          replaceToken
        }

        replacedBy {
          ...MetadataNodeFragment
          replaceToken
        }

        courseTypeNode {
          id
          name
        }
      }
    }
  }
  ${METADATA_NODE_FRAGMENT}
`

export default DISH_TYPE_NODE_FRAGMENT
